const currencyObj = {
    CNY: { code: '¥', text: '人民币' },
    THB: { code: '฿', text: '泰铢' },
    IDR: { code: 'Rp', text: '印尼盾' },
    KRW: { code: '₩', text: '韩币' },
    USD: { code: '$', text: '美元' },
    MYR: { code: 'MYR', text: '马币' },
    HKD: { code: '$', text: '港币' }
}

const getCurrencySymbol = (key) => {
    if (key) {
        const obj = currencyObj[key]
        return obj ? obj.code : ''
    }
    return ''

}

export { currencyObj, getCurrencySymbol }